module.exports = __webpack_public_path__ + "static/media/aa-placeholder.5f28889d.jpg";